<template>
  <section class="sights-skeleton">
    <PageWrap>
      <SkeletonItem
        class="sights-skeleton__title"
        width="280px"
        height="32px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
    </PageWrap>

    <div class="sights-skeleton__viewport">
      <div class="sights-skeleton__row">
        <div
          v-for="n in 6"
          :key="n"
          class="sights-skeleton__card"
        >
          <SkeletonItem
            width="100%"
            height="100%"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  import PageWrap from '@/shared/ui/PageWrap.vue';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  .sights-skeleton {
    position: relative;
    padding: 40px 0 0;
    overflow: hidden;

    &__title {
      margin-bottom: 24px;
    }

    &__viewport {
      width: 100vw;
      min-width: var(--wrap-min-width);
      max-width: var(--wrap-max-width);
      padding: 0 var(--wrap-offset);
      margin: 0 auto;

      @include tablet {
        box-sizing: border-box;
        padding: 0;
      }
    }

    &__row {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 16px;

      @include tablet {
        grid-template-columns: repeat(3, 1fr);
      }

      @include mobile {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    &__card {
      width: 100%;
      height: 263px;
    }

    @include mobile {
      padding: 32px 0 0;
    }
  }
</style>
